import React, { useCallback, useEffect, useState } from "react";
import FiltersDrawer from "./FiltersDrawer";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../reducers/mapaExecucao.actions";
import {
  getDominioDispositivos,
  getDominioEmpresas,
  getDominioGrupos,
  getDrawer,
  getFiltros,
} from "../../../selectors/mapaExecucao.selectors";
import useCompleteForm from "../../../hooks/useCompleteForm";
import { getUsuario } from "../../../selectors/usuario.selectors";
import validators from "../../../utils/validators";

const FilterDrawerConnected = () => {
  const dispatch = useDispatch();
  const { filters: filtersVisible } = useSelector(getDrawer);
  const filtros = useSelector(getFiltros);
  const { empresa, roteiro } = useSelector(getUsuario);
  const { data: dataEmpresas } = useSelector(getDominioEmpresas);
  const { data: dataDispositivos } = useSelector(getDominioDispositivos);
  const { data: dataGrupos } = useSelector(getDominioGrupos);
  const [showRoteiro, setShowRoteiro] = useState(false);

  const handleClose = useCallback(() => {
    dispatch(actions.exibirFiltros(false));
  }, [dispatch]);

  const [formProps, handleSubmit] = useCompleteForm({
    rules: (f) => ({
      mesAnoString: validators.string({
        required: true,
      }),
      empresa: validators.string({
        required: true,
      }),
      horarioInicio: validators.string({
        required: false,
        custom: {
          requiredIfOther: (value) => {
            if (!value) return true;
            if (value.length !== 5) {
              return "Horário inválido";
            }

            let hour = Number(value.slice(0, 2));
            let minute = Number(value.slice(3, 5));

            if (hour < 0 || hour > 23) {
              return "Horário inválido";
            }
            if (minute < 0 || minute > 59) {
              return "Horário inválido";
            }
            const max = f.getValues("horarioTermino");

            if (!!max) {
              if (value.localeCompare(max) > 0) {
                return "Não pode ser maior que o Horário Início (Até)";
              }
            }

            return true;
          },
        },
      }),
      horarioTermino: validators.string({
        required: false,
        custom: {
          requiredIfOther: (value) => {
            if (!value) return true;
            if (value.length !== 5) {
              return "Horário inválido";
            }

            let hour = Number(value.slice(0, 2));
            let minute = Number(value.slice(3, 5));

            if (hour < 0 || hour > 23) {
              return "Horário inválido";
            }
            if (minute < 0 || minute > 59) {
              return "Horário inválido";
            }

            const min = f.getValues("horarioInicio");

            if (!!min) {
              if (value.localeCompare(min) < 0) {
                return "Não pode ser menor que o Horário Início (De)";
              }
            }
            return true;
          },
        },
      }),
      minCheckpoints: validators.number({
        required: false,
        custom: {
          _100: (value) =>
            !value || value <= 100 || "Valor não pode ser maior do que 100",
          small: (value) => {
            const max = f.getValues("maxCheckpoints");
            return (
              !value ||
              !max ||
              value <= max ||
              "Valor não pode ser maior do que % Checkpoints Máx."
            );
          },
        },
      }),
      maxCheckpoints: validators.number({
        required: false,
        custom: {
          _100: (value) =>
            !value || value <= 100 || "Valor não pode ser maior do que 100",
          small: (value) => {
            const min = f.getValues("minCheckpoints");
            return (
              !value ||
              !min ||
              value >= min ||
              "Valor não pode ser menor do que % Checkpoints Min."
            );
          },
        },
      }),
    }),
    initialValues: () => ({
      mesAnoString: `${new Date(filtros.mesAno).getFullYear()}-${
        new Date(filtros.mesAno).getMonth() > 8
          ? new Date(filtros.mesAno).getMonth() + 1
          : "0" + (new Date(filtros.mesAno).getMonth() + 1)
      }`,
      empresa: dataEmpresas.find((el) => el.id === empresa) ?? null,
      os: "",
      roteiro: "",
      dispositivo: null,
      grupo: null,
      minCheckpoints: "",
      maxCheckpoints: "",
      horarioInicio: "",
      horarioTermino: "",
      funcionamento: [],
      ordem: "inicio",
    }),
    handleSubmit: (values) => {
      values.mesAno = new Date(
        values.mesAnoString.slice(0, 4),
        values.mesAnoString.slice(5, 7),
        0
      );

      dispatch(actions.atualizarFiltros({ ...values, page: 1 }));
      handleClose();
    },
  });

  const { reset, setValue } = formProps;

  const handleChangeEmpresa = useCallback(
    (item) => {
      setValue("grupo", null);
      if (item === null) {
        dispatch(actions.carregarGrupos.success({ response: { data: [] } }));
        setShowRoteiro(true);
      } else {
        dispatch(actions.carregarGrupos.request({ id: item.id }));
        if (item.roteiro === "N") {
          setShowRoteiro(false);
        } else {
          setShowRoteiro(true);
        }
      }
    },
    [dispatch, setValue]
  );

  useEffect(() => {
    if (!!filtersVisible && !!filtros) {
      reset(filtros);
    }
  }, [filtros, reset, filtersVisible]);

  useEffect(() => {
    if (dataEmpresas.find((el) => el.id === empresa)) {
      dispatch(
        actions.atualizarFiltros({
          empresa: dataEmpresas.find((el) => el.id === empresa),
        })
      );
    }
    // eslint-disable-next-line
  }, [empresa, dataEmpresas]);

  useEffect(() => {
    setShowRoteiro(!empresa ? true : roteiro === "S" ? true : false);
    if (empresa === null) {
      dispatch(actions.atualizarFiltros());
    }
    // eslint-disable-next-line
  }, [empresa]);

  return (
    <FiltersDrawer
      handleClose={handleClose}
      visible={filtersVisible}
      formProps={formProps}
      handleSubmit={handleSubmit}
      handleChangeEmpresa={handleChangeEmpresa}
      showEmpresa={!empresa}
      domainEmpresas={dataEmpresas}
      domainDispositivos={dataDispositivos}
      domainGrupo={dataGrupos}
      empresa={empresa}
      showRoteiro={showRoteiro}
    />
  );
};

export default FilterDrawerConnected;
